<script>
export default {
	name: 'MainLogo',
}
</script>

<template>
	<router-link
		to="/"
		class="main-logo flex items-center gap-x-[7.93px] max-w-[189px] font-main font-light text-second no-underline text-[14px] leading-[0.81] hover:no-underline hover:text-second"
	>
		<img src="@/assets/logo.svg" :alt="$t('logoTitle')" class="w-[42px] block shrink-0" />
		<span v-html="$t('logoTitle')" />
	</router-link>
</template>

<style>
.main-logo span strong {
	font-weight: 800 !important;
	font-size: 12px;
	line-height: 0.9;
	text-transform: uppercase;
}
</style>
